// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <p>VA’s Community Care Eligibility API utilizes VA’s Facility API, VA's Enrollment &amp; Eligibility system and others to satisfy requirements found in the VA MISSION Act of 2018. Please visit the official <a href="https://missionact.va.gov/">VA MISSION Act of 2018</a> page for more information about the specific requirements.</p>
      <p>The Community Care Eligibility API allows consumers to provide Veterans the ability to know if they meet the following MISSION Act requirements:</p>
      <ul>
      <li>If a Veteran needs a service (one of the services returned from VA’s Facility API) it will show the nearest VA facility that meets your needs, calculating average drive times. Please see VA’s <a href="/explore/facilities/docs/facilities">Facility endpoint</a> for drive time calculation specifics</li>
      <li>If a Veteran needs a service and there are no VA Facilities in the Veteran's state or territory, it will display the Veteran’s community care eligibility</li>
      <li>Using the VA’s Enrollment and Eligibility system it will identify if a Veteran is eligible for the “Grandfather” Provision</li>
      <li>If the VA cannot furnish care within certain designated access standards, it will display a Veteran's community care eligibility (for the specified 12 services mentioned above)</li>
      </ul>
    </div>
  );
};

export default MarkdownComponent;
